import {DTO} from '@/shared';
import {METHOD, ENDPOINT} from '@/constants';

export interface IQueryGetInvoice {
  limit?: number;
  page?: number;
  name?: string;
  tenantId?: string;
  paymentStatus?: number;
  sort?: string;
  billMonth?: string;
  departmentName?: string;
}
export interface IQueryLangInvoice {
  lang?: string;
}
export interface IQueryGetInvoiceDetail {
  limit: number;
  page: number;
}
export class GetListInvoiceDTO extends DTO {
  public param: undefined;
  public url = ENDPOINT.INVOICE;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryGetInvoice;
  constructor(query: IQueryGetInvoice) {
    super();
    this.query = query;
  }
}
export class DetailInvoiceDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.INVOICE_DETAIL;
  public method = METHOD.GET;
  public body: undefined;
  public readonly responseClass: unknown;
  public query: IQueryGetInvoiceDetail;
  constructor(param: {id: number}, query: IQueryGetInvoiceDetail) {
    super();
    this.param = param;
    this.query = query;
  }
}
export class ConfirmPaidDTO extends DTO {
  public body: {isActive: boolean};
  public url: string = ENDPOINT.CONFIRM_PAID;
  public method = METHOD.PATCH;
  public param: {id: number | undefined};
  public query: undefined;
  constructor(
    param: {id: number | undefined},
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    body: any,
  ) {
    super();
    this.param = param;
    this.body = body;
  }
}
export class ExportExcelDetailInvoiceDTO extends DTO {
  public param: {id: number} | undefined;
  public url = ENDPOINT.INVOICE_EXPORT_DETAIL;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;
  public query: IQueryLangInvoice;
  constructor(param: {id: number}, query: IQueryLangInvoice) {
    super();
    this.responseType = 'blob';
    this.param = param;
    this.query = query;
  }
}

export class GetInvoiceCurentDTO extends DTO {
  public query: IQueryGetInvoice;
  public param: undefined;
  public url = ENDPOINT.INVOICE_CURRENT;
  public method = METHOD.GET;
  public body: unknown;
  public readonly responseClass: unknown;

  constructor(query: IQueryGetInvoice) {
    super();
    this.query = query;
  }
}
